define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"csi/action",
	"csi/def/Action",
	"csi/heading/Attribute",
	"csi/widget/RadioButton",
	"csi/xml"
], function(declare, lang, domClass, action, Action, Attribute, RadioButton, xml) {
	return declare(Attribute, {
		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: render Node Name heading if item is unlinked
			ctx.pushParams().setNodeURL(ctx.view.setupSettingsUrl);
			ctx.__popContext = true;
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: pop context if pushed above
			ctx.pop();
		},

		toHtmlStatic: function( /*Context*/ ctx, /*Heading*/ h, /*DOMNode*/ refNode, /*ActionData*/ actionData) {
			//summary: renderer for ExceptionReportKey, creates radio buttons on table so that one theme placement attribute can be set as a key
			var value = this._getValue(ctx, h);
			var node = ctx.getNodeContext();
			var bSelected = (node.$Name == value);
			//not editable if BOMLineAttributeId is not selected
			var bEdit = actionData && !actionData.bTooltip && !!node.BOMLineAttributeId;
			var radioName = h.m_nameOrig;

			var radio = new RadioButton({
				name: radioName,
				disabled: !bEdit,
				value: node.$Name
			}).placeAt(refNode);

			//setting radio button status as radio button can't be checked until its created
			radio.set("checked", bEdit && bSelected);

			if (bEdit) {
				radio.onClick = function() {
					action.invoke(ctx.view, refNode, lang.mixin(new Action(), {
						m_id: radioName + "Edit",
						m_onAction: function(ac) {
							ac.m_writer.changeNode(ctx.view.setupSettingsUrl)
								.changeAttribute(h.m_id, xml.ATTR_STRING, bSelected ? "" : node.$Name)
								.changeAttribute("Modified", xml.ATTR_BOOLEAN, true);
						},
						m_postAction: "postActionRedraw"
					}), {
						bHold: true
					});
				};
			}

			if (node.Modified || (bSelected && ctx.view.currentExceptionReportKey != value) || (node.$Name == ctx.view.currentExceptionReportKey && value == "")) {
				//makes the row color yellow to show its a pending change
				domClass.add(refNode.parentNode, "pendingUpdate");
			}
			return true;
		}
	});
});